import { Apis } from '../../app.constants';
import SweetAlert from '../../../components/Shared/Notification';
import APIService from '../../../Services/APIService';
import { alertAtom, orderListObjAtom, productListObjAtom, userInformationAtom } from '../../_states';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';

const ECommerceActions = () => {
  const [productDataObj, setProductDataObj] = useRecoilState(productListObjAtom);
  const loggedInUserInfo = useRecoilValue(userInformationAtom)
  // const [orderStatusDataObj, setOrderStatusDataObj] = useRecoilState(orderStatusAtom);
  const [orderDataObj, setOrderDataObj] = useRecoilState(orderListObjAtom);
  const setIsLoading = useSetRecoilState(alertAtom);

  const getProductItemList = async (data) => {
    let res = await APIService.get(
      `${Apis.getProductItemList}?next_page=${data?.page + 1}&search=${data?.search}&sort_by=${data?.sortField}&sort_order=${data?.sortOrder}&category=${data?.category || ''}&availability=${data?.availability || ''}&catalog_id=${data?.catalog_id || ''}&bot_number=${data?.bot_number || ''}`
    );
    if (res?.status === 200) {
      setProductDataObj(res?.data);
      return res?.data;
    } else SweetAlert('Failed to fetch product list', 'error');
  };
  const refreshProductList = async (data) => {
    let res = await APIService.post(`${Apis.refreshProductList}`, data);
    if (res?.status === 200) {
      return res?.data;
    } else SweetAlert('Failed to reload', 'error');
  };

  const getCatalogList = async (botNumber) => {
    let res = await APIService.get(`${Apis.getCatalogList}?bot_number=${botNumber}`);
    if (res?.status === 200) return res?.data;
    else SweetAlert('Failed to fetch product list', 'error');
  };
  const postProductSetsList = async (data) => {
    let res = await APIService.post(`${Apis.postProductSetsList}`, data);
    if (res?.status === 200) return res?.data;
    else SweetAlert('Failed to fetch product sets', 'error');
  };
  const getProductSetsList = async (data) => {
    let res = await APIService.get(`${Apis.postProductSetsList}`);
    if (res?.status === 200) return res?.data;
    else SweetAlert('Failed to fetch product sets', 'error');
  };

  const getOrderList = async (data) => {
    setOrderDataObj({ ...orderDataObj, list: [] });
    setIsLoading(true);
    let res = await APIService.get(
      `${Apis.getOrderList}?next_page=${data?.page + 1}&search=${data?.search}&sort_by=${data?.sortField || 'order_date'}&sort_order=${data?.sortOrder || 'desc'}&order_status=${data?.order_status}&payment_status=${data?.payment_status}&order_start_date=${data?.orderStartDate || ''}&order_end_date=${data?.orderEndDate || ''}&channel_sales_partner=${data?.channel_sales_partner || ''}&cities=${data?.cities || ''}&limit=${data?.limit || 10}&organisation=${data?.organisation || ''}&botNumber=${data?.botNumber || ''}`
    );
    if (res?.status === 200) {
      setOrderDataObj(res?.data);
      setIsLoading(false);
      return res?.data;
    } else SweetAlert('Failed to fetch order list', 'error');
    setIsLoading(false);
  };

  const updateOrderPaymentStatus = async (data) => {
    let res = await APIService.put(`${Apis.getOrderList}`, data);
    if (res?.status === 200) return res?.data;
    else SweetAlert('Failed to fetch order list', 'error');
  };

  const getChannelSalesPartners = async (data) => {
    let res = await APIService.get(
      `${Apis.getChannelSalesPartners}?next_page=${data?.page + 1}&search=${data?.search}`
    );
    if (res?.status === 200) return res?.data;
    else SweetAlert('Failed to channel sales partners', 'error');
  };

  const exportOrderData = async (data) => {
    let organisation_id = loggedInUserInfo?.profile?.organisation?.organisation_id;
    if (organisation_id)
      window.location.href = `${process.env.REACT_APP_API_URL}/${Apis.downloadOrderData}?search=${data?.search}&sort_by=${data?.sortField}&sort_order=${data?.sortOrder}&order_status=${data?.order_status}&payment_status=${data?.payment_status}&order_start_date=${data?.orderStartDate || ''}&order_end_date=${data?.orderEndDate || ''}&cities=${data?.cities || ''}&channel_sales_partner=${data?.channel_sales_partner || ''}&company_id=${organisation_id}`;
    else SweetAlert('Organisation id is not found', 'warning');
  };

  const uploadOrderStatus = async (formData) => {
    let res = await APIService.post(`${Apis.downloadOrderData}`, formData, {
      'Content-Type': 'multipart/form-data',
    });
    if (res?.status === 200) {
      SweetAlert('File uploaded successfully', 'success');
      return res?.data;
    } else if (res?.status === 400)
      SweetAlert(res?.data?.data?.general_error?.errors || 'Failed to Update Status', 'warning');
    else SweetAlert('Failed to Update Status', 'error');
  };

  const updateProductItem = async (data) => {
    let res = await APIService.put(`${Apis.produtItem}`, data);
    return res;
  };

  const createProductItem = async (data) => {
    let res = await APIService.post(`${Apis.produtItem}`, data);
    return res;
  };

  const deleteProductItem = async (data) => {
    let res = await APIService.remove(
      `${Apis.produtItem}?bot_number=${data?.bot_number || ''}&product_id=${data?.p_id || ''}&uuid=${data?.uuid || ''}`
    );
    if (res?.status === 200) {
      // SweetAlert(res?.data?.data, "success");
      let productList = productDataObj?.list?.filter((item) => item?.uuid !== data?.uuid);
      setProductDataObj({ ...productDataObj, list: productList });
    } else
      // SweetAlert("Failed to delete product", "success");
      console.log('Failed to delete product');
    return res;
  };

  const getOrderCityList = async (data) => {
    let res = await APIService.get(
      `${Apis.getOrderCityList}?next_page=${data?.page + 1}&search=${data?.search}`
    );
    if (res?.status === 200) return res?.data;
    else SweetAlert('Failed to fetch city list', 'error');
  };
  const getOrderDataById = async (id) => {
    let res = await APIService.get(`${Apis.getOrderDetails}?order_id=${id}`);
    if (res?.status === 200) {
      return res?.data;
    } else SweetAlert('Failed to fetch order data', 'error');
  };

  return {
    getProductItemList,
    refreshProductList,
    getCatalogList,
    postProductSetsList,
    getProductSetsList,
    getOrderList,
    updateOrderPaymentStatus,
    exportOrderData,
    uploadOrderStatus,
    getChannelSalesPartners,
    updateProductItem,
    createProductItem,
    deleteProductItem,
    getOrderCityList,
    getOrderDataById,
  };
};

export { ECommerceActions };
